import * as React from 'react';
import { CDN_PREFIX } from './Const';
export var Icon = props => {
  var iconUrl = props.iconUrl,
    alt = props.alt;
  return React.createElement("img", {
    src: CDN_PREFIX + iconUrl,
    alt: alt
  });
};